import React from 'react';
import {
    Wheat,
    Milk,
    Egg,
    Fish,
    Shrimp,
    Shell,
    Nut,
    FlaskConical,
    LeafyGreen,
    CircleDot,
    Bean,
    Droplets
} from 'lucide-react';

const icons: { [key: string]: React.ElementType } = {
    gluten: Wheat,
    leche: Milk,
    huevo: Egg,
    pescado: Fish,
    crustaceos: Shrimp,
    moluscos: Shell,
    nuts: Nut,
    sulfitos: FlaskConical,
    apio: LeafyGreen,
    mostaza: CircleDot,
    sesamo: CircleDot,
    soja: Bean,
    altramuces: Bean,
    crustaceo: Shrimp,
    molusco: Shell,
};

interface AllergenIconProps {
    allergen: string;
    size?: number;
    className?: string;
}

const AllergenIcon: React.FC<AllergenIconProps> = ({ allergen, size = 16, className = "" }) => {
    const Icon = icons[allergen.toLowerCase()];
    if (!Icon) return null;

    return (
        <div className={`group relative inline-flex items-center justify-center ${className}`} title={allergen}>
            <Icon size={size} className="text-earth-dark/40 group-hover:text-terracotta transition-colors" />
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 px-2 py-1 bg-earth-dark text-white text-[10px] rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none mb-2 whitespace-nowrap z-50 capitalize">
                {allergen}
            </span>
        </div>
    );
};

export default AllergenIcon;
